import type { FlamioConfig } from './types';

// Periodic FullSnapshot so deep clip-seeks start from a nearby snapshot; without
// it, long sessions fast-forward past rrweb's replayer limit -> blank replay.
const DEFAULT_CHECKOUT_INTERVAL_MS = 30_000;

// Skip-recording conventions — keep identical to the browser extension
// (apps/extension/src/content/index.ts) so a customer's markup works on both.
const MASK_CLASS = 'flamio-mask';
const BLOCK_CLASS = 'flamio-block';
const IGNORE_CLASS = 'flamio-ignore';
const MASK_ATTR_SELECTOR = '[data-flamio-mask]';

export interface RecordPrivacySelectors {
  /** rrweb `maskTextSelector` additions — text blanked. */
  maskSelectors: string[];
  /** rrweb `blockSelector` — matching elements omitted from the recording. */
  blockSelectors: string[];
}

export function getRecordConfig(
  config: FlamioConfig,
  selectors: RecordPrivacySelectors
): Record<string, unknown> | null {
  if (config.consent === 'denied' || config.consent === 'wait') {
    return null;
  }

  const recordConfig: Record<string, unknown> = {
    // Always mask input values — we never record what users type. Not configurable.
    maskAllInputs: true,
    maskTextClass: MASK_CLASS,
    maskTextSelector: [MASK_ATTR_SELECTOR, ...selectors.maskSelectors].join(
      ','
    ),
    blockClass: BLOCK_CLASS,
    ignoreClass: IGNORE_CLASS,
    maskInputOptions: {
      password: true,
      email: true,
      tel: true,
    },
    maskTextContent: config.maskTextContent ?? false,
    checkoutEveryNms: config.checkoutEveryNms ?? DEFAULT_CHECKOUT_INTERVAL_MS,
  };

  if (selectors.blockSelectors.length > 0) {
    recordConfig.blockSelector = selectors.blockSelectors.join(',');
  }

  return recordConfig;
}
